import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ShopQueryParams } from '../models/shop-query-params.model';

@Injectable()
export class NavigationService {

  shopQueryParams = new BehaviorSubject<ShopQueryParams>(null);

  col0 = new BehaviorSubject(null);
  col1 = new BehaviorSubject(null);
  col2 = new BehaviorSubject(null);

  constructor() { }
}
